import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Project } from '../../../helpers/types';
import { CreateProjectPayload } from '../../../services/projectsApi';
import { ProjectsState } from './types';

export const initialState: ProjectsState = {
  items: [],
  loading: false,
  creating: false,
  error: null,
};

export const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    fetchRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<Project[]>) {
      state.loading = false;
      state.items = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createRequest(state, _action: PayloadAction<CreateProjectPayload>) {
      state.creating = true;
    },
    createSuccess(state, action: PayloadAction<Project>) {
      state.creating = false;
      state.items.unshift(action.payload);
    },
    createFailure(state) {
      state.creating = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    deleteRequest(state, _action: PayloadAction<string>) {},
    deleteSuccess(state, action: PayloadAction<string>) {
      state.items = state.items.filter((p) => p.id !== action.payload);
    },
  },
});

export const { actions: projectsActions } = projectsSlice;

export const useProjectsSlice = () => ({ actions: projectsSlice.actions });
